// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_button__5w9H- {
  font-weight: 700;
  font-size: 1.8rem;
  padding: 12px 20px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  line-height: 1.4rem;
  width: 100%;
  transition: background-color 0.3s, box-shadow 0.3s, transform 0.3s;
}
.style_button__disabled__TUfVV {
  opacity: 0.5;
}
.style_button__5w9H- span {
  font-size: 1.4rem;
  font-weight: bold;
}

.style_button__icon__9dXye {
  font-size: 2.4rem;
  margin-right: 8px;
}

.style_spinner__aTcjC {
  width: 20px;
  height: 20px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top-color: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  animation: style_spin__42mvt 1s linear infinite;
}

@keyframes style_spin__42mvt {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.style_button-primary__jQinJ.style_button-orange__kOf3v {
  background: rgb(255, 174, 7);
  color: rgb(71, 57, 21);
  border: 2px solid rgb(255, 255, 255);
  transition: background-color 0.3s, box-shadow 0.3s, transform 0.3s;
  box-shadow: 2px 2px 0px rgb(255, 199, 1), 3px 3px 0px rgb(255, 255, 255);
}
.style_button-primary__jQinJ.style_button-orange__kOf3v:active, .style_button-primary__jQinJ.style_button-orange__kOf3v.style_loading__c3VW8 {
  box-shadow: 0 0 0px rgb(255, 199, 1);
  transform: scale(0.97);
}
.style_button-primary__jQinJ.style_button-orange__kOf3v .style_spinner__aTcjC {
  border: 3px solid transparent;
  border-top-color: rgb(198, 143, 0);
}

.style_button-primary__jQinJ.style_button-green__DILcX {
  background: #39b283;
  border: 2px solid rgb(255, 255, 255);
  transition: background-color 0.3s, box-shadow 0.3s, transform 0.3s, rotate 0.3s, shadow-color 0.3s;
  box-shadow: 2px 2px 0px #1f4c3a, 3px 3px 0px rgb(255, 255, 255);
}
.style_button-primary__jQinJ.style_button-green__DILcX:active, .style_button-primary__jQinJ.style_button-green__DILcX.style_loading__c3VW8 {
  box-shadow: 0 0 0 #1f4c3a;
  transform: scale(0.97);
}
.style_button-primary__jQinJ.style_button-green__DILcX .style_spinner__aTcjC {
  border: 3px solid transparent;
  border-top-color: #1f6b4e;
  animation: style_spin__42mvt 1s linear infinite;
}
.style_button-primary__jQinJ.style_button-green__DILcX span {
  color: #1f4c3a;
}

.style_button-outlined__6PQj-.style_button-orange__kOf3v {
  background: transparent;
  color: rgb(255, 174, 7);
  border: 2px solid rgb(255, 174, 7);
}

.style_button-text__5IAPX.style_button-orange__kOf3v {
  background: transparent;
  color: rgb(255, 174, 7);
  border: none;
}

.style_button-primary__jQinJ.style_button-grey__0AlXE {
  background: rgb(158, 158, 158);
  border: 2px solid rgb(255, 255, 255);
  box-shadow: 2px 2px 0px rgb(158, 158, 158);
  transition: background-color 0.3s, box-shadow 0.3s, transform 0.3s;
  box-shadow: 2px 2px 0px rgb(158, 158, 158), 3px 3px 0px rgb(255, 255, 255);
}
.style_button-primary__jQinJ.style_button-grey__0AlXE:active {
  box-shadow: 0 0 0px rgb(158, 158, 158);
  transform: scale(0.97);
}
.style_button-primary__jQinJ.style_button-grey__0AlXE span {
  color: rgb(47, 47, 47);
}

.style_button-outlined__6PQj-.style_button-grey__0AlXE {
  background: transparent;
  color: rgb(158, 158, 158);
  border: 2px solid rgb(158, 158, 158);
  box-shadow: 2px 2px 0px rgb(158, 158, 158);
}

.style_button-text__5IAPX.style_button-grey__0AlXE {
  background: transparent;
  color: rgb(158, 158, 158);
  border: none;
}

.style_button-primary__jQinJ.style_button-purple__0m7UN {
  background: rgb(117, 83, 240);
  color: rgb(255, 255, 255);
  border: 2px solid #ffffff;
  box-shadow: 2px 2px 0px rgb(117, 83, 240);
}

.style_button-outlined__6PQj-.style_button-purple__0m7UN {
  background: transparent;
  color: rgb(255, 255, 255);
  border: 2px solid rgb(255, 255, 255);
  box-shadow: 2px 2px 0px rgb(117, 83, 240);
}

.style_button-text__5IAPX.style_button-purple__0m7UN {
  background: transparent;
  color: rgb(117, 83, 240);
  border: none;
}
.style_button-text__5IAPX.style_button-purple__0m7UN i {
  color: rgb(117, 83, 240);
}

.style_button-text__5IAPX.style_button-black__45854 {
  background: transparent;
  color: rgb(27, 27, 27);
  border: none;
}
.style_button-text__5IAPX.style_button-black__45854 i {
  color: rgb(27, 27, 27);
}

.style_button__5w9H-:active {
  box-shadow: 0 0 0px rgb(255, 255, 0);
  transform: scale(0.97);
}

.style_button__5w9H-.style_loading__c3VW8 {
  box-shadow: 0 0 0px;
  transform: scale(0.97);
}

.style_button-small__14-O9 {
  padding: 12px 15px;
  height: 37px;
  font-size: 1.2rem;
}

.style_button-medium__FEKrX {
  padding: 16px 20px;
  height: 47px;
  font-size: 1.6rem;
}

.style_button-large__8icWS {
  padding: 16px 20px;
  height: 47px;
  font-size: 1.8rem;
}
.style_button-large__8icWS span {
  font-size: 1.8rem;
}`, "",{"version":3,"sources":["webpack://./src/components/button/style.module.scss","webpack://./public/assets/colors.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EAIA,WAAA;EACA,kEACE;AALJ;AAAE;EACE,YAAA;AAEJ;AAME;EACE,iBAAA;EACA,iBAAA;AAJJ;;AAQA;EACE,iBAAA;EACA,iBAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EACA,0CAAA;EACA,kBAAA;EACA,+CAAA;AALF;;AAQA;EACE;IACE,uBAAA;EALF;EAOA;IACE,yBAAA;EALF;AACF;AAQA;EACE,4BAAA;EACA,sBAAA;EACA,oCAAA;EACA,kEACE;EAGF,wEACE;AAVJ;AAYE;EAEE,oCAAA;EACA,sBAAA;AAXJ;AAcE;EACE,6BAAA;EACA,kCAAA;AAZJ;;AAgBA;EACE,mBClEY;EDmEZ,oCAAA;EACA,kGACE;EAKF,+DACE;AAnBJ;AAsBE;EAEE,yBAAA;EACA,sBAAA;AArBJ;AAwBE;EACE,6BAAA;EACA,yBCrFI;EDsFJ,+CAAA;AAtBJ;AAyBE;EACE,cCzFS;ADkEb;;AA2BA;EACE,uBAAA;EACA,uBAAA;EACA,kCAAA;AAxBF;;AA2BA;EACE,uBAAA;EACA,uBAAA;EACA,YAAA;AAxBF;;AA2BA;EACE,8BC7GK;ED8GL,oCAAA;EACA,0CAAA;EACA,kEACE;EAGF,0EACE;AA5BJ;AA8BE;EACE,sCAAA;EACA,sBAAA;AA5BJ;AA+BE;EACE,sBAAA;AA7BJ;;AAiCA;EACE,uBAAA;EACA,yBAAA;EACA,oCAAA;EACA,0CAAA;AA9BF;;AAiCA;EACE,uBAAA;EACA,yBAAA;EACA,YAAA;AA9BF;;AAiCA;EACE,6BCvJK;EDwJL,yBCnJM;EDoJN,yBAAA;EACA,yCAAA;AA9BF;;AAiCA;EACE,uBAAA;EACA,yBC1JM;ED2JN,oCAAA;EACA,yCAAA;AA9BF;;AAiCA;EACE,uBAAA;EACA,wBCtKK;EDuKL,YAAA;AA9BF;AA+BE;EACE,wBCzKG;AD4IP;;AAiCA;EACE,uBAAA;EACA,sBC7KY;ED8KZ,YAAA;AA9BF;AA+BE;EACE,sBChLU;ADmJd;;AAiCA;EACE,oCAAA;EACA,sBAAA;AA9BF;;AAiCA;EACE,mBAAA;EACA,sBAAA;AA9BF;;AAiCA;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;AA9BF;;AAiCA;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;AA9BF;;AAiCA;EACE,kBAAA;EACA,YAAA;EACA,iBAAA;AA9BF;AA+BE;EACE,iBAAA;AA7BJ","sourcesContent":["@import 'public/assets/colors';\n\n.button {\n  font-weight: 700;\n  font-size: 1.8rem;\n  padding: 12px 20px;\n  height: 50px;\n  border-radius: 12px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  line-height: 1.4rem;\n  &__disabled {\n    opacity: 0.5;\n  }\n  width: 100%;\n  transition:\n    background-color 0.3s,\n    box-shadow 0.3s,\n    transform 0.3s;\n\n  span {\n    font-size: 1.4rem;\n    font-weight: bold;\n  }\n}\n\n.button__icon {\n  font-size: 2.4rem;\n  margin-right: 8px;\n}\n\n.spinner {\n  width: 20px;\n  height: 20px;\n  border: 3px solid rgba(255, 255, 255, 0.3);\n  border-top-color: rgba(255, 255, 255, 0.9);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.button-primary.button-orange {\n  background: rgba(255, 174, 7, 1);\n  color: rgba(71, 57, 21, 1);\n  border: 2px solid $white;\n  transition:\n    background-color 0.3s,\n    box-shadow 0.3s,\n    transform 0.3s;\n  box-shadow:\n    2px 2px 0px $yellow,\n    3px 3px 0px $white;\n  &:active,\n  &.loading {\n    box-shadow: 0 0 0px $yellow;\n    transform: scale(0.97);\n  }\n\n  .spinner {\n    border: 3px solid transparent;\n    border-top-color: rgba(198, 143, 0, 1);\n  }\n}\n\n.button-primary.button-green {\n  background: $light-green;\n  border: 2px solid $white;\n  transition:\n    background-color 0.3s,\n    box-shadow 0.3s,\n    transform 0.3s,\n    rotate 0.3s,\n    shadow-color 0.3s;\n  box-shadow:\n    2px 2px 0px $dark-green,\n    3px 3px 0px $white;\n\n  &:active,\n  &.loading {\n    box-shadow: 0 0 0 $dark-green;\n    transform: scale(0.97);\n  }\n\n  .spinner {\n    border: 3px solid transparent;\n    border-top-color: $green;\n    animation: spin 1s linear infinite;\n  }\n\n  span {\n    color: $dark-green;\n  }\n}\n\n.button-outlined.button-orange {\n  background: transparent;\n  color: rgba(255, 174, 7, 1);\n  border: 2px solid rgba(255, 174, 7, 1);\n}\n\n.button-text.button-orange {\n  background: transparent;\n  color: rgba(255, 174, 7, 1);\n  border: none;\n}\n\n.button-primary.button-grey {\n  background: $grey;\n  border: 2px solid $white;\n  box-shadow: 2px 2px 0px $grey;\n  transition:\n    background-color 0.3s,\n    box-shadow 0.3s,\n    transform 0.3s;\n  box-shadow:\n    2px 2px 0px $grey,\n    3px 3px 0px $white;\n  &:active {\n    box-shadow: 0 0 0px $grey;\n    transform: scale(0.97);\n  }\n\n  span {\n    color: rgba(47, 47, 47, 1);\n  }\n}\n\n.button-outlined.button-grey {\n  background: transparent;\n  color: rgba(158, 158, 158, 1);\n  border: 2px solid rgba(158, 158, 158, 1);\n  box-shadow: 2px 2px 0px rgba(158, 158, 158, 1);\n}\n\n.button-text.button-grey {\n  background: transparent;\n  color: rgba(158, 158, 158, 1);\n  border: none;\n}\n\n.button-primary.button-purple {\n  background: $main;\n  color: $white;\n  border: 2px solid #ffffff;\n  box-shadow: 2px 2px 0px $main;\n}\n\n.button-outlined.button-purple {\n  background: transparent;\n  color: $white;\n  border: 2px solid $white;\n  box-shadow: 2px 2px 0px $main;\n}\n\n.button-text.button-purple {\n  background: transparent;\n  color: $main;\n  border: none;\n  i {\n    color: $main;\n  }\n}\n\n.button-text.button-black {\n  background: transparent;\n  color: $black-extra;\n  border: none;\n  i {\n    color: $black-extra;\n  }\n}\n\n.button:active {\n  box-shadow: 0 0 0px rgba(255, 255, 0, 1);\n  transform: scale(0.97);\n}\n\n.button.loading {\n  box-shadow: 0 0 0px;\n  transform: scale(0.97);\n}\n\n.button-small {\n  padding: 12px 15px;\n  height: 37px;\n  font-size: 1.2rem;\n}\n\n.button-medium {\n  padding: 16px 20px;\n  height: 47px;\n  font-size: 1.6rem;\n}\n\n.button-large {\n  padding: 16px 20px;\n  height: 47px;\n  font-size: 1.8rem;\n  span {\n    font-size: 1.8rem;\n  }\n}\n","$main: rgba(117, 83, 240, 1);\n$light-main: rgba(237, 235, 254, 1);\n$black-extra: rgba(27, 27, 27, 1);\n$dark-grey: rgba(135, 135, 135, 1);\n$light-background: rgba(247, 246, 255, 1);\n$white: rgba(255, 255, 255, 1);\n$light-grey: rgba(213, 212, 220, 1);\n$yellow: rgba(255, 199, 1, 1);\n$grey: rgba(158, 158, 158, 1);\n$light-green: #39b283;\n$green: #1f6b4e;\n$dark-green: #1f4c3a;\n$danger: #c10000;\n$red: #e73232;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `style_button__5w9H-`,
	"button__disabled": `style_button__disabled__TUfVV`,
	"button__icon": `style_button__icon__9dXye`,
	"spinner": `style_spinner__aTcjC`,
	"spin": `style_spin__42mvt`,
	"button-primary": `style_button-primary__jQinJ`,
	"button-orange": `style_button-orange__kOf3v`,
	"loading": `style_loading__c3VW8`,
	"button-green": `style_button-green__DILcX`,
	"button-outlined": `style_button-outlined__6PQj-`,
	"button-text": `style_button-text__5IAPX`,
	"button-grey": `style_button-grey__0AlXE`,
	"button-purple": `style_button-purple__0m7UN`,
	"button-black": `style_button-black__45854`,
	"button-small": `style_button-small__14-O9`,
	"button-medium": `style_button-medium__FEKrX`,
	"button-large": `style_button-large__8icWS`
};
export default ___CSS_LOADER_EXPORT___;
